var Colors = {
    PRIMARY_COLOR: '#51139A',
    SECONDARY_COLOR: '#FFB142',
    HIGHLIGHT_COLOR: '#00887A',
    WHITE: '#FFFFFF',
    TONED_WHITE: '#F2F2F2',
    WHITE_TWO: '#F1F1F1',
    LOGIN_BUTTON_COLOR: '#00887A',
    SIGNUP_BUTTON_COLOR: '#00887A',
    LIGHT_GRAY: '#E2E2E2',
    VERY_LIGHT_GRAY: '#F0F0F0',
    GRAY: '#818181',
    DARK_GRAY: '#363636',
    BLACK: '#000000',
    ERROR_COLOR: '#EA3342',
    SUCCESS_COLOR: '#009C04',
    BACKGROUND_COLOR: '#F9F9F9',
    CHECK_SELECTED_COLOR: '#7CD914',
    PALE_GRAY: '#EDE9F4',
    DULL_GREEN: '#369683',
    BACKDROP: 'rgba(0,0,0,0.2)',
    BLUE: '#425994',
    LIGHT_BLUE: '#4285F4',
    AMBER: '#FFE082',
    LIGHT_AMBER: '#FFF8E1',
    PROFILE_ICON_COLORS: ['#E64579', '#fabc60', '#E77980', '#F3AD76', '#FAE3C3'],
    LIGHT_BLACK: '#4E4E4E',
    KOURNIKOVA: '#FACD5D',
    NIGHT_RIDER: '#2D2D2D',
    SPUN_PEARL: '#A3A3A4',
    ASH_GREY: '#BABABB',
    DARK_GREY: '#7A7A7A',
    GREY_TWO: '#9A9A9A',
    SCROLLBAR_GREY: '#7f7f7f',
    BACKGROUND_GREY: '#f7f7f7',
    SILVER_SAND: '#C6C6C6',
    DARK_LIVER: '#4E4E4E',
    RED: '#FF0000',
    BURNT_UMBER: '#222222',
    GREY_FIVE: '#EFEFEF',
    GREY_THREE: '#A4B0BE',
    GREEN: '#5ABC7B',
    // ratings colors
    RATING_ONE: '#CC2F2C',
    RATING_TWO: '#D04C2B',
    RATING_THREE: '#D6682D',
    RATING_FOUR: '#E29832',
    RATING_FIVE: '#FFAF13',
    RATING_SIX: '#C0CA44',
    RATING_SEVEN: '#97C24D',
    RATING_EIGHT: '#82B846',
    RATING_NINE: '#71AB45',
    RATING_TEN: '#5F963F'
};

export { Colors as default };
//# sourceMappingURL=colors.js.map
